
import { Button } from "@/components/ui/button";
import { Plus, Database } from "lucide-react";
import { useSettings } from "@/providers/SettingsProvider";
import { useState } from "react";
import { generateDummyJobs } from "@/utils/dummy-data/jobs";
import { toast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";


interface JobsActionsProps {
  onAddClick: () => void;
  onJobsGenerated?: () => void;
}

export const JobsActions = ({ onAddClick, onJobsGenerated }: JobsActionsProps) => {

  const { t } = useTranslation();

  const { devMode } = useSettings();
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerateDummyData = async () => {
    try {
      setIsGenerating(true);
      const jobs = await generateDummyJobs(8);
      if (jobs) {
        toast({
          title: "Success",
          description: `Generated ${jobs.length} dummy job offers with matches`,
        });
        
        // Call the callback to refresh jobs list
        if (onJobsGenerated) {
          onJobsGenerated();
        }
      }
    } catch (error) {
      console.error("Failed to generate job data:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="flex gap-2">
      {devMode && (
        <Button 
          variant="outline" 
          onClick={handleGenerateDummyData}
          disabled={isGenerating}
          className="flex items-center gap-2"
        >
          <Database className="h-4 w-4" />
          {isGenerating ? "Generating..." : "Generate Dummy Data"}
        </Button>
      )}
      <Button onClick={onAddClick} className="bg-digger-blue hover:bg-digger-blue-light">
        <Plus className="h-4 w-4 mr-2" />
        {t("jobs.formWizard.title")}
      </Button>
    </div>
  );
};
